import React, { PureComponent } from "react";
import styled from "styled-components";
import posed from "react-pose";
import { Link } from "react-router-dom";
import Emoji from "../../components/Emoji/Emoji";
import ShareButtons from "../../components/ShareButtons";
import { colors } from "../../theme";
import Icon from "@fortawesome/react-fontawesome";

const ListWrapper = styled(
  posed.div({
    show: {
      opacity: 1,
      x: 0
    },
    hidden: {
      x: 600
    }
  })
)`
  position: absolute;
  right: 20px;
  top: 30px;
  bottom: 40px;
  width: 400px;
  background-color: ${colors.grayTrans};
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  @media (min-width: 575px) {
    display: flex;
  }
  @media (max-width: 576px) {
    display: ${props => (!props.selectedEmoji ? "none" : "flex")};
    width: auto;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
  }
`;

const ListTitle = styled.h2`
  margin: 0px;
  padding: 20px;
  color: white;
  background-color: ${colors.blue};
  font-size: 20px;
  flex: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-overflow: ellipsis;
`;

const ListTitleRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ScrollView = styled.div`
  overflow: auto;
  flex: 50;
`;

const List = styled.div`
  padding: 20px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const StyledEmoji = styled(Emoji)`
  font-size: 40px;
  min-width: 80px;
`;

const EmojiTitle = styled.h3`
  margin: 0;
  font-size: 25px;
  line-height: 25px;
  margin-bottom: 10px;
  color: ${colors.darkGreen};
`;

const EmojiBody = styled.p`
  font-size: 18px;
  margin: 0;
`;

const CloseLink = styled(Link)`
  text-align: right;

  color: white;
  text-decoration: none;
  font-size: 20px;

  @media (min-width: 575px) {
    position: absolute;
    top: -15px;
    right: -15px;
    background-color: ${colors.darkGreen};
    border: 3px solid white;
    padding: 5px;
    border-radius: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 27px;
    height: 27px;
  }
`;

const Highlight = styled.div`
  background-color: ${colors.blue};
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 20px;
`;

const MoreTitle = styled.h2`
  margin: 20px 20px 0px 20px;
  color: ${colors.green};
`;

const PartyLink = styled.a`
  background-color: ${colors.darkGreen};
  color: white;
  font-weight: bold;
  padding: 20px;
  margin: 0 auto;
  text-decoration: none;
  margin: 50px 20px;
  display: block;
  text-align: center;
  border-radius: 4px;
`;

class ListView extends PureComponent {
  render() {
    const { party, city, emojis, selectedEmoji, returnUrl } = this.props;
    let emojiList = [];
    let highlight = null;
    if (!selectedEmoji) {
      emojiList = emojis;
    } else {
      emojiList = emojis.filter(e => e.id !== selectedEmoji);
      let highlightList = emojis.filter(e => e.id === selectedEmoji);
      highlight = highlightList.length ? highlightList[0] : null;
    }

    return (
      <ListWrapper
        selectedEmoji={selectedEmoji}
        key="listWrapper"
        pose={party ? "show" : "hidden"}
      >
        <ListTitle selected={selectedEmoji}>
          {!selectedEmoji && `${party ? party.name : ""}`}
          <ListTitleRight>
            <ShareButtons small="true" party={party} city={city} mode="party" />

            <CloseLink to={returnUrl}>
              <Icon icon={["far", "times"]} />
            </CloseLink>
          </ListTitleRight>
        </ListTitle>

        <ScrollView>
          {highlight && (
            <Highlight>
              <StyledEmoji>{highlight.emoji}</StyledEmoji>

              <div>
                <EmojiTitle>{highlight.title}</EmojiTitle>
                <EmojiBody>{highlight.body}</EmojiBody>
              </div>
            </Highlight>
          )}

          {selectedEmoji && (
            <MoreTitle>Meer voorstellen van {party.name}</MoreTitle>
          )}

          <List>
            {emojiList && emojiList.length ? (
              emojiList.map(emoji => (
                <ListItem key={`${emoji.id}`}>
                  <StyledEmoji>{emoji.emoji}</StyledEmoji>

                  <div>
                    <EmojiTitle>{emoji.title}</EmojiTitle>
                    <EmojiBody>{emoji.body}</EmojiBody>
                  </div>
                </ListItem>
              ))
            ) : (
              <EmojiTitle>
                {party ? party.name : ""} heeft nog geen voorstellen ingediend.
              </EmojiTitle>
            )}

            {party &&
              party.website && (
                <PartyLink href={party.website} target="_blank">
                  Bezoek website
                </PartyLink>
              )}
          </List>
        </ScrollView>
      </ListWrapper>
    );
  }
}

export default ListView;



// WEBPACK FOOTER //
// ./src/pages/City/ListView.js